import { render } from "./ConsentDialog.vue?vue&type=template&id=21e70a7e&scoped=true"
import script from "./ConsentDialog.vue?vue&type=script&lang=js"
export * from "./ConsentDialog.vue?vue&type=script&lang=js"

import "./ConsentDialog.vue?vue&type=style&index=0&id=21e70a7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e70a7e"]])

export default __exports__